// import { exampleSong } from './exampleSong';
import { combineReducers } from 'redux';

import {
  // SAVE_SONG_REQUEST,
  // SAVE_SONG_FAILURE,
  // SAVE_SONG_SUCCESS,
  // DOWNLOAD_SONG,
  // LOAD_SONG_REQUEST,
  LOAD_SONG_SUCCESS,
  // LOAD_SONG_FAILURE,
  NEW_SONG,
} from '../actions/song';
// import { REPLACE_LINE, UPDATE_LINE } from '../actions/line';

import lines from './lines';
import structure from './structure';
import sections from './sections';
import meta from './meta';
import rhymes from './rhymes';
import linegroups from './linegroups';
import { FIRESTORE_SONG_RECEIVED } from '../actions/firestore';

const defaultSongState = {
  // title: "New Song",
  // authors: [],
  // key: "",
  // structure: [],
  // sections: {byId:{}, allIds: []},
  // lines: {byId:{}, allIds: []},
  // lineGroups: [],
  // rhymes: [],
  // filename: "",
};

const overall = (state = defaultSongState, action) => {
  switch (action.type) {
  // case DOWNLOAD_SONG:
  // case SAVE_SONG_REQUEST:
  // case SAVE_SONG_FAILURE:
  // case SAVE_SONG_SUCCESS:
  //   // TODO: Store something that this action happened
  //   return state;

  case LOAD_SONG_SUCCESS:
  case FIRESTORE_SONG_RECEIVED:
    return {
      ...action.obj,
      meta: { ...action.obj.meta, filename: action.filename },
    };

  case NEW_SONG:
    return {};

    // case CHANGE_SONG_FIELD:
    //   return {
    //     ...state,
    //     [action.field]: action.value,
    //   };

    // case CREATE_SECTION:
    //     const newState1 = Object.assign({}, state)
    //     // If there are lyrics, create the lines
    //     let lineIds = [];
    //     if (action.fields.lyrics) {
    //         lineIds = action.fields.lyrics.split("\n").map(ln => ln.trim()).filter(ln => ln).map(ln => {
    //             const id = getNextId(newState1.lines);
    //             newState1.lines[id] = {text: ln, syllables: null, stresses: null};
    //             return id;
    //         })
    //     }

    //     // Add a new section into the state
    //     const newId1 = getNextId(newState1.sections)
    //     newState1.sections[newId1] = {
    //         label: action.fields.label,
    //         type: action.fields.type,
    //         lines: lineIds,
    //     }
    //     // If we have an index, insert it into the song structure
    //     if (!isNaN(parseInt(action.index, 10))) {
    //         newState1.structure.splice(action.index, 0, newId1)
    //     }

    //     // Done, so return the new state
    //     return newState1;

    // case UPDATE_LINE:
    //   return state;

    // case REPLACE_LINE:
    //   const newState2 = Object.assign({}, state);
    //   state.sections[action.sectionId].lines[action.lineIndex] = action.newLineId;
    //   return newState2;

    // case CREATE_ALT_LINE:
    //   const newLineId2 = getNextId(state.lines);
    //   const newState3 = {...state,};
    //   newState3.lines = {
    //     ...newState3.lines,
    //     [newLineId2]: getUpdatedLine(newState3.lines[action.lineId], action.values),
    //   };

    //   let foundAGroup = false;
    //   newState3.lineGroups = newState3.lineGroups.map(grp => {
    //     if (grp.indexOf(action.lineId) >= 0) {
    //       foundAGroup = true;
    //       const newGroup = grp.slice(0);
    //       newGroup.push(newLineId2);
    //       return newGroup;
    //     }
    //     return grp;
    //   })
    //   if (!foundAGroup) {
    //     newState3.lineGroups.push([action.lineId, newLineId2]);
    //   }

    //   return newState3;

  default:
    return state;
  }
};

const combined = combineReducers({
  meta,
  // title: noop,
  // authors: noop,
  // key: noop,
  structure,
  sections,
  lines,
  linegroups,
  rhymes,
  // filename: noop,
});

const song = (state = {}, action) => combined(overall(state, action), action);

export default song;



// WEBPACK FOOTER //
// ./src/reducers/song.js